import { z } from "zod";
import { isoDateStringSchema } from "./common";

const LANGS = ["en", "fr", "ar", "es", "it", "de", "nl"] as const;

/** A music style in all seven site locales; genre names are shown verbatim per locale. */
export const eventStyleSchema = z.object({
  en: z.string().trim().min(1).max(80),
  fr: z.string().trim().min(1).max(80),
  ar: z.string().trim().min(1).max(80),
  es: z.string().trim().min(1).max(80),
  it: z.string().trim().min(1).max(80),
  de: z.string().trim().min(1).max(80),
  nl: z.string().trim().min(1).max(80),
});
export type EventStyle = z.infer<typeof eventStyleSchema>;

export const activityEventWriteSchema = z.object({
  id: z.string().uuid().optional(),
  eventDate: isoDateStringSchema,
  startTime: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, "HH:MM")
    .nullable()
    .optional(),
  djName: z.string().trim().min(1).max(191),
  musicStyle: eventStyleSchema.nullable().optional(),
  photoUrl: z.string().url().nullable().optional(),
  ticketPrice: z.number().int().nonnegative().nullable().optional(),
  prepaymentRequired: z.boolean().default(false),
});
export type ActivityEventWrite = z.infer<typeof activityEventWriteSchema>;

export const setActivityEventsSchema = z.object({
  events: z.array(activityEventWriteSchema).max(200),
});

/** Staff view: every locale of the style, past nights included. */
export const activityEventManageDtoSchema = activityEventWriteSchema.extend({
  id: z.string().uuid(),
  musicStyle: eventStyleSchema.nullable(),
  startTime: z.string().nullable(),
  photoUrl: z.string().nullable(),
  ticketPrice: z.number().int().nullable(),
});
export type ActivityEventManageDto = z.infer<typeof activityEventManageDtoSchema>;

/** Public view: upcoming nights, style already resolved to the requested locale. */
export const activityEventDtoSchema = z.object({
  id: z.string().uuid(),
  eventDate: z.string(),
  startTime: z.string().nullable(),
  djName: z.string(),
  musicStyle: z.string().nullable(),
  photoUrl: z.string().nullable(),
  ticketPrice: z.number().int().nullable(),
  prepaymentRequired: z.boolean(),
});
export type ActivityEventDto = z.infer<typeof activityEventDtoSchema>;

export const ACTIVITY_EVENT_LANGS = LANGS;
